import { ValidateOptions, Result } from '@/types';
import { ResultCode, ErrorCode, NGwords } from '@/definition';

export const getStrLen = (txt: string) => {
  return [...txt].length;
};

export const validate = (val: string, option?: ValidateOptions) => {
  // initialize result object
  const result: Result = {
    resultCode: ResultCode.SUCCESS,
    errorCode: ErrorCode.NO_ERROR,
    errorMsg: '',
  };

  // empty check
  if (!val) {
    result.resultCode = ResultCode.VALIDATION_ERROR;
    result.errorCode = ErrorCode.EMPTY;
    result.errorMsg = '1文字以上入力してください。';
    return result;
  }

  // NG word check
  const _val = String(val);
  for (const NGword of NGwords) {
    if (_val.includes(NGword)) {
      result.resultCode = ResultCode.VALIDATION_ERROR;
      result.errorCode = ErrorCode.INCLUDE_NG_WORD;
      result.errorMsg = '利用できない言葉が含まれています。';
      return result;
    }
  }

  if (option) {
    const validType = option.type;

    if (validType === 'number') {
      const numberVal = Number(val);

      // 0禁止
      if (option?.denyZero) {
        if (numberVal === 0) {
          result.resultCode = ResultCode.VALIDATION_ERROR;
          result.errorCode = ErrorCode.DENY_ZERO_NUM;
          result.errorMsg = '0は指定できません。';
          return result;
        }
      }

      // 負の値禁止
      if (option?.denyNegativeNum) {
        if (numberVal < 0) {
          result.resultCode = ResultCode.VALIDATION_ERROR;
          result.errorCode = ErrorCode.DENY_NEGATIVE_NUM;
          result.errorMsg = '0以下の値は指定できません。';
          return result;
        }
      }

      // 最大値
      if (option?.maxVal) {
        if (numberVal > option?.maxVal) {
          result.resultCode = ResultCode.VALIDATION_ERROR;
          result.errorCode = ErrorCode.OVER_MAX_VAL;
          result.errorMsg = `最大値（${option?.maxVal}）を超えた数値は指定できません。`;
          return result;
        }
      }

      // 最小値
      if (option?.minVal) {
        if (numberVal > option?.minVal) {
          result.resultCode = ResultCode.VALIDATION_ERROR;
          result.errorCode = ErrorCode.UNDER_MIN_VAL;
          result.errorMsg = `最小値（${option?.minVal}）を下回る数値は指定できません。`;
          return result;
        }
      }
    } else if (validType === 'password') {
      const minPassLength = 4;

      // パスワードの長さチェック
      if (val.length < minPassLength) {
        result.resultCode = ResultCode.VALIDATION_ERROR;
        result.errorCode = ErrorCode.NOT_ENOUGH_LENGTH;
        result.errorMsg = `パスワードは${minPassLength}文字以上にしてください。`;
        return result;
      }
    } else if (validType === 'string') {
      // 文字列の最大の長さ
      if (option?.maxLen) {
        if (getStrLen(val) > option.maxLen) {
          result.resultCode = ResultCode.VALIDATION_ERROR;
          result.errorCode = ErrorCode.OVER_MAX_LEN;
          result.errorMsg = `入力は${option.maxLen}文字以内にしてください。`;
          return result;
        }
      }
      // 文字列の最小の長さ
      if (option?.minLen) {
        if (getStrLen(val) < option.minLen) {
          result.resultCode = ResultCode.VALIDATION_ERROR;
          result.errorCode = ErrorCode.UNDER_MIN_LEN;
          result.errorMsg = `入力は${option.minLen}文字以上にしてください。`;
          return result;
        }
      }
    }
  }

  return result;
};
